export const SUPPORT_LINKS_ANALYTICS_ATTRIBUTES = {
    location: 'page',
    category: 'action',
    actions: {
        customerSupport: 'support',
        faq: 'faq'
    }
};
